import classNames from 'classnames';
import getHref, {
  urlType as urlTypeProps
} from '../../../helpers/getHref';

import Icon from '../../Atoms/Icon';

export interface SocialItemProps {
  icon:
    | 'facebook'
    | 'instagram'
    | 'linkedin'
    | 'twitter'
    | 'mail'
    | 'whatsapp'
    | 'phone'
    | 'comments';

  url: string;
  urlType?: urlTypeProps;
  tooltip?: string;
}

export interface Props {
  socialItems: SocialItemProps[];
  className?: string;
  iconClassName?: string;
  rounded?: boolean;
  contacts?: boolean;
}

function SocialBar({
  socialItems,
  className,
  iconClassName,
  rounded,
  contacts
}: Props) {
  return (
    socialItems && (
      <ul
        className={classNames(
          'flex flex-wrap items-center text-2xl',
          !contacts ? 'gap-5' : 'gap-2 md:flex-nowrap',
          className
        )}
      >
        {socialItems.map(
          ({ url, urlType = 'link', icon, tooltip }) => (
            <li key={icon}>
              <a
                className={classNames([
                  !rounded
                    ? 'text-sl-blue duration-300 hover:text-sl-indigo'
                    : 'inline-flex items-center justify-center rounded-full text-center shadow-button-depth-1 transition-colors ',
                  contacts
                    ? 'h-12 w-12 bg-white text-sl-blue'
                    : rounded &&
                      'h-14 w-14 bg-sl-blue text-white hover:bg-sl-blue-dark',
                  iconClassName,
                  'group relative flex hover:z-10'
                ])}
                href={getHref(url, urlType)}
                target="_blank"
                rel="noreferrer"
              >
                <Icon icon={icon} />
                {tooltip && (
                  <>
                    <span
                      className="pointer-events-none absolute top-full left-1/2 mt-3.5 -translate-x-1/2 opacity-0 duration-300 group-hover:opacity-100"
                      style={{
                        width: '0',
                        height: '0',
                        borderLeft: '5px solid transparent',
                        borderRight:
                          '5px solid transparent',
                        borderBottom: '6px solid #ffcf4b'
                      }}
                    />
                    <span className="pointer-events-none absolute top-full left-1/2 mt-5 -translate-x-1/2 whitespace-nowrap rounded-md bg-sl-yellow px-2 py-1 font-circular text-xs font-bold text-sl-blue opacity-0 duration-300 group-hover:pointer-events-auto group-hover:opacity-100">
                      {tooltip}
                    </span>
                  </>
                )}
              </a>
            </li>
          )
        )}
      </ul>
    )
  );
}

export default SocialBar;
